import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { ListItem, RepositoryModal, TireVendor, TireVendorRoute } from '../../shared'
import { TIRE_EQUIPMENT_CLASSES, UTAH_COUNTIES } from '../../field-tools/equipment-report/report-components/tire-report.model'

@Component({
    templateUrl: './tire-vendor-route-modal.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent, WjInputModule],
})
export class TireVendorRouteModalComponent extends RepositoryModal<TireVendorRoute> {
    countyOptions = [new ListItem('*', 'All counties (*)'), ...UTAH_COUNTIES.map(c => new ListItem(c, c))]
    equipmentClassOptions = TIRE_EQUIPMENT_CLASSES.map(c => new ListItem(c.value, c.label))
    vendorOptions: ListItem<string>[] = []

    protected override onInitialized() {
        this.services.data.load(true, true, this.services.data.tireVendors.queryAll()).subscribe({
            next: result => {
                this.vendorOptions = (result[0] ?? []).map((v: TireVendor) => new ListItem(v.name, v.id))
            },
        })
    }
}
